import store from 'util/data/store';
import sideNavModel from 'models/side-nav-model';
import appModel from 'models/app-model';
import formModel from 'models/form-model';


const ProjectMenu = {
    view: () => {
        const metaProjectId = store.account.attributes.metaProjectId,
            projectName = store.project.name;
        return <div class="project-menu vertical-menu side-nav-popup">
            <div class="padding-wrap">
                {!!projectName && <div class="side-nav-popup-title">{projectName}</div>}
                <ul class="side-nav-popup-links menu-links">
                    <li class="side-nav-popup-item menu-item">
                        <a onclick={() => formModel.validateThenRun(() => sideNavModel.openMetaAsset('Properties'))} class="UFtracker-u-menu-properties">
                            <i class="icon-asset-form" /> Properties
                        </a>
                    </li>
                    <li class="side-nav-popup-item menu-item">
                        <a onclick={() => formModel.validateThenRun(() => sideNavModel.openMetaAsset('Comments'))} class="UFtracker-u-menu-comments">
                            <i class="icon-comment" /> Comments
                        </a>
                    </li>
                    <li class="side-nav-popup-item menu-item">
                        <a onclick={() => formModel.validateThenRun(() => sideNavModel.openMetaAsset('Links'))} class="UFtracker-u-menu-links">
                            <i class="icon-link" /> Links
                        </a>
                    </li>                  
                    <li class="side-nav-popup-item menu-item">
                        <a onclick={() => formModel.validateThenRun(() => sideNavModel.openMetaAsset('People'))} class="UFtracker-u-menu-people">
                            <i class="icon-user" /> People
                        </a>
                    </li>
                    {!!appModel.user.isAccountAdmin && <>
                        <li class="side-nav-popup-item menu-item">
                            <a onclick={() => formModel.validateThenRun(() => sideNavModel.openMetaAsset('Places/Levels'))} class="UFtracker-u-menu-places">
                                <i class="icon-place-with-levels" /> Places/Levels
                            </a>
                        </li>
                    </>}
                </ul>
            </div>
            <div class="project-menu-footer">
                <a class="btn btn-pill btn-secondary btn-smaller UFtracker-view-portfolio" onclick={() => formModel.validateThenRun(() => {
                    window.location.href = `/#projectId=${metaProjectId}`;
                })}><span class="btn-label">View Portfolio</span></a>
            </div>
        </div>;
    }

};

export default ProjectMenu;
